import { MenuItem } from "../hooks/api/queries/useMenu";
import { flattenTree } from "./constructSlug";

interface Props {
  categorySlug?: string;
  menu?: MenuItem[];
}
export const categoryDepth = ({ categorySlug, menu }: Props) => {
  if (!categorySlug || !menu) return { depth: -1, category: null };
  const menuFlat = flattenTree(menu);
  const category = menuFlat.find((item) => item.slug === categorySlug);
  let depth = 0;
  let temp = category;
  while (temp && temp?.parentId !== null) {
    depth += 1;
    // eslint-disable-next-line no-loop-func
    temp = menuFlat.find((cat) => cat.id === temp?.parentId);
  }
  return { depth, category };
};
